module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n<ngx-spinner\n  bdOpacity = 0.7\n  bdColor = \"#333\"\n  size = \"medium\"\n  color = \"#8a627c\"\n  type = \"line-scale-party\">Loading...</ngx-spinner>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main